import { Link } from 'react-router-dom';
import { getHotPosts } from '@/utils/content';

export default function TrendingTicker() {
  const items = getHotPosts(6);
  const loop = [...items, ...items];

  return (
    <section className="w-full bg-foreground-950 text-background-100 border-b border-foreground-800">
      <div className="w-full flex items-center">
        <div className="shrink-0 flex items-center gap-2 h-12 px-4 md:px-6 bg-primary-500 text-background-50">
          <i className="ri-pulse-line"></i>
          <span className="text-sm font-medium whitespace-nowrap">今日热榜</span>
        </div>
        <div className="flex-1 overflow-hidden">
          <div className="marquee-track flex w-max items-center">
            {loop.map((post, index) => (
              <Link
                key={`${post.slug}-${index}`}
                to={`/post/${post.slug}`}
                className="flex items-center gap-2 px-5 py-3.5 text-sm text-background-200 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span className="text-accent-400 text-xs">
                  {String((index % items.length) + 1).padStart(2, '0')}
                </span>
                {post.title}
                <span className="text-background-400/60">·</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}